import { BaseMessageInfo } from "./BaseMessageInfo";
import { SearchTarget } from "../enums/SearchTarget";

export class DQOIMessageInfo extends BaseMessageInfo
{
    canCreate: boolean;
    fromSearchTarget: SearchTarget;
    toSearchTarget: SearchTarget;
    fromId: any;
}
